<!-- svelte-ignore missing-declaration -->
<script>
import { ShadowRoot } from './libraries/ShadowRoot.js';
import CoreRegister from './register/CoreRegister.svelte';
import Styles from './Styles.svelte';
import variable_styles from "tripod-styles/src/sass/variables.scss";
import { turpial } from './libraries/turpial.js';
import { PlansSizeStore } from './plans/PlansSizeStore.js';

let style = document.createElement("style");
style.innerText = variable_styles;
document.body.appendChild(style);

window.turpial = turpial;

let show = false;
setTimeout(() => {
    show = true;
    console.log($ShadowRoot)
}, 100);


let width_container = 0;
$: PlansSizeStore.set(width_container); 
$: console.log($PlansSizeStore)
</script>
<div class="svelte-module sv" bind:clientWidth={width_container}>
    {#if show}
        <Styles />
        <CoreRegister />
    {/if}
</div>